<ng-container *ngIf="isLoad$">
    <div class="flex flex-col h-full overflow-hidden">
        <div class="flex flex-row header gap-x-[8px]">
            <div class="flex flex-row basis-1/2">
                <app-menu-button
                    (buttonClick)="clickMenuButton($event)"
                    #menuButtonComponent
                    [buttonConf]="{
                        icon: 'dots-vertical',
                        color: 'light',
                        height: 'normal',
                        borderRadius: 'rounded',
                    }"
                    [buttons$]="buttons$"
                >
                </app-menu-button>
            </div>
            <div class="flex flex-row gap-x-[8px] basis-full">
                <div class="select-1 remove-form-field-wrapper shrink-0">
                    <ng-container
                        dynamic-field
                        [field]="{
                            type: 'select',
                            label: dictionary?.system_items_per_page_label,
                            name: 'status',
                            withoutChooseField: true,
                            options: registers.statuses,
                        }"
                        [group]="form"
                    >
                    </ng-container>
                </div>
                <div class="select-2 remove-form-field-wrapper shrink-0">
                    <ng-container
                        dynamic-field
                        [field]="{
                            type: 'select',
                            label: dictionary?.system_sort,
                            name: 'order',
                            withoutChooseField: true,
                            options: registers.sortFiled,
                        }"
                        [group]="form"
                    >
                    </ng-container>
                </div>
            </div>
        </div>
        <mat-divider></mat-divider>
        <div class="h-full overflow-y-auto">
            <ng-container *ngIf="isLoad$ | async; else skeletonLoader">
                <div class="flex flex-col" cdkScrollable>
                    <ng-container *ngIf="notifyList$ | async as list">
                        <ng-container *ngFor="let item of list">
                            <mat-expansion-panel
                                (click)="$event.stopPropagation()"
                                (opened)="changeStatus(item, NOTIFY_STATUSES.read)"
                                expanded="false"
                                class="notify-row"
                            >
                                <mat-expansion-panel-header>
                                    <mat-panel-title class="flex-row">
                                        <div class="w-[16px]">
                                            <span class="status" [ngClass]="item.status"> </span>
                                        </div>
                                        <div class="flex flex-row justify-between w-full">
                                            <div class="ml-[8px]">
                                                <b>{{ item?.factor_name }}.</b>&nbsp;{{ item.name }}
                                            </div>
                                            <ng-container *ngIf="item?.created_at">
                                                <div class="ml-[8px] w-[70px] shrink-0">
                                                    <span>{{ item?.created_at | myDate: 'dd.MM.yyyy' }}</span>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <mat-divider></mat-divider>
                                <div class="pl-[16px]" [innerHTML]="item?.body"></div>
                            </mat-expansion-panel>
                        </ng-container>
                        <ng-container *ngIf="list?.length === 0">
                            <span class="p-[8px] leading-7">{{ dictionary?.notifications_list_by_filter_empty }}</span>
                        </ng-container>
                    </ng-container>
                </div>
            </ng-container>
            <ng-template #skeletonLoader>
                <div class="px-[8px] pt-[8px] gap-y-[8px]">
                    <ng-container *ngFor="let i of skeletonArrCount">
                        <ngx-skeleton-loader count="1" appearance="line" SkeletonLoader [theme]="skeletonConf">
                        </ngx-skeleton-loader>
                    </ng-container>
                </div>
            </ng-template>
        </div>
    </div>
</ng-container>
